import React, { useEffect, useState } from 'react';
import { Download, FileText, Loader2, Sparkles, X } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { KiAuswertung } from './Ki';

const BILD = /\.(jpe?g|png|webp|gif)$/i;

export const blobLaden = async (url) => (await api.get(url, { responseType: 'blob' })).data;
export const speichern = (blob, name) => {
  const u = URL.createObjectURL(blob);
  const l = document.createElement('a'); l.href = u; l.download = name; document.body.appendChild(l); l.click(); l.remove(); URL.revokeObjectURL(u);
};

export const erfassungDateien = (a) => {
  const id = a.anfrage_id;
  const aus = (m, label, key) => (m?.gridfs_id || m?.stored_filename ? [{ label, url: `/admin/anfragen/${id}/ausweis/${key}`, name: `${label.replace(/\s/g, '_')}${(m.stored_filename || '').slice((m.stored_filename || '').lastIndexOf('.'))}`, typ: m.content_type || '' }] : []);
  return [
    ...aus(a.ausweis_front, 'Ausweis Vorderseite', 'vorderseite'),
    ...aus(a.ausweis_back, 'Ausweis Rückseite', 'rueckseite'),
    ...(a.case_docs || []).map((c) => ({ idx: c.idx, label: c.original_filename || `Dokument ${c.idx}`, url: `/admin/anfragen/${id}/case-doc/${c.idx}`, name: c.original_filename || `dokument_${c.idx}`, typ: c.content_type || '' })),
  ];
};

const art = (f, blob) => {
  const t = blob?.type || f.typ;
  if (/pdf/.test(t) || /\.pdf$/i.test(f.name)) return 'pdf';
  if (/^image\/(jpeg|png|webp|gif)/.test(t) || BILD.test(f.name)) return 'bild';
  return 'sonst';
};

const Kachel = ({ f, i, onOeffnen, onKi }) => {
  const [b, setB] = useState(null);
  const [ki, setKi] = useState(false);
  const [url, setUrl] = useState('');
  const [fehler, setFehler] = useState(false);
  useEffect(() => {
    let u = '';
    blobLaden(f.url).then((x) => { setB(x); u = URL.createObjectURL(x); setUrl(u); }).catch(() => setFehler(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [f.url]);
  const a = b ? art(f, b) : null;
  return (
    <li className="group rounded-xl border border-gray-200 bg-white overflow-hidden hover:border-[#b8893d] hover:shadow-md transition-[border-color,box-shadow] duration-200" data-testid={`erfassung-datei-${i}`}>
      <button type="button" disabled={!b} onClick={() => onOeffnen({ ...f, blob: b, url, art: a })} className="block w-full aspect-[4/3] bg-[#f5f8fa] relative" data-testid={`erfassung-datei-vorschau-${i}`}>
        {fehler ? <span className="absolute inset-0 flex items-center justify-center text-[11px] text-rose-700">Nicht ladbar</span>
          : !b ? <Loader2 className="absolute inset-0 m-auto w-5 h-5 animate-spin text-[#b8893d]" />
          : a === 'bild' ? <img src={url} alt={f.label} className="w-full h-full object-cover" />
          : a === 'pdf' ? <iframe title={f.label} src={`${url}#toolbar=0&navpanes=0&view=FitH`} className="w-full h-full pointer-events-none bg-white" />
          : <span className="absolute inset-0 flex flex-col items-center justify-center gap-1 text-[11px] text-[#34536b]"><FileText className="w-6 h-6 text-[#b8893d]" />Keine Vorschau</span>}
      </button>
      <div className="flex items-center gap-2 px-3 py-2 border-t border-gray-100">
        <span className="text-xs text-[#1B3A5C] truncate flex-1" title={f.label}>{f.label}</span>
        <button type="button" disabled={!b} onClick={() => speichern(b, f.name)} className="text-[#34536b] hover:text-[#b8893d]" title="Herunterladen" data-testid={`erfassung-datei-download-${i}`}><Download className="w-3.5 h-3.5" /></button>
        {f.idx != null && onKi && <button type="button" disabled={ki} onClick={async () => { setKi(true); try { await onKi(f); } finally { setKi(false); } }} className="text-[#b8893d] hover:text-[#1B3A5C]" title="Mit KI auswerten (Frist, Behörde, Aktenzeichen)" data-testid={`erfassung-datei-ki-${i}`}>{ki ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}</button>}
      </div>
    </li>
  );
};

export const Gross = ({ f, onClose }) => (
  <div className="rounded-xl bg-[#0B1724] overflow-hidden flex flex-col h-[70vh]" data-testid="erfassung-datei-gross">
    <div className="flex items-center gap-3 px-4 py-2.5 text-white">
      <span className="flex-1 truncate text-sm">{f.label}</span>
      {f.blob && <button type="button" onClick={() => speichern(f.blob, f.name)} className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-white/30 hover:border-[#e0b56a] transition-colors duration-200"><Download className="w-3.5 h-3.5" /> Herunterladen</button>}
      <button type="button" onClick={onClose} className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full hover:bg-white/10 transition-colors duration-200" data-testid="erfassung-datei-gross-schliessen"><X className="w-4 h-4" /> Zurück</button>
    </div>
    <div className="flex-1 min-h-0 bg-[#f5f8fa] flex items-center justify-center">
      {f.art === 'bild' ? <img src={f.url} alt={f.label} className="max-w-full max-h-full object-contain" />
        : f.art === 'pdf' ? <iframe title={f.label} src={f.url} className="w-full h-full bg-white" />
        : <p className="text-[#34536b] text-sm">Für dieses Format gibt es keine Vorschau – bitte herunterladen.</p>}
    </div>
  </div>
);

export const ErfassungVorschau = ({ a, onOeffnen }) => {
  const [aus, setAus] = useState(null);
  const [fehler, setFehler] = useState('');
  const files = erfassungDateien(a);
  if (!files.length) return null;
  const onKi = async (f) => {
    setFehler('');
    try { const r = await api.post('/kanzlei/ki/dokument', { anfrage_id: a.anfrage_id, idx: f.idx }, { timeout: 180000 }); setAus({ ...r.data, datei: f.label }); } catch (e) { setFehler(e?.response?.data?.detail || 'KI-Auswertung fehlgeschlagen'); }
  };
  return (
    <section className="sm:col-span-2" data-testid="erfassung-dateien">
      <h4 className="text-[10px] tracking-[0.2em] uppercase text-[#b8893d] mb-2">Dokumente ({files.length})</h4>
      <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3">{files.map((f, i) => <Kachel key={f.url} f={f} i={i} onOeffnen={onOeffnen} onKi={onKi} />)}</ul>
      {fehler && <p className="text-xs text-rose-700 mt-2" data-testid="ki-auswertung-fehler">{fehler}</p>}
      {aus && <KiAuswertung e={aus} onClose={() => setAus(null)} />}
    </section>
  );
};
